import { GlobalStyleProps } from '@chakra-ui/theme-tools'

export const styles = {
    global: ({ theme }: GlobalStyleProps) => ({
        'body #hubspot-messages-iframe-container': {
            zIndex: theme.zIndices.overlay,
        },
    }),
}
